import { defineStore } from "pinia";
import { ref, computed } from "vue"; // Import von ref und computed aus Vue

export const useBaseStore = defineStore("baseStore", () => {
  // Initialisiere windowWidth mit einem Standardwert, falls window nicht verfügbar ist
  const windowWidth = ref(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  const isMobile = computed(() => windowWidth.value < 768);
  const isIpadAndBelow = computed(() => windowWidth.value < 1450);
  const showMenueRechts = computed(() => windowWidth.value >= 1450);
  const isDesktop = computed(() => windowWidth.value >= 770);
  const screenSize = computed(() => windowWidth.value);
  const thisYear = computed(() => new Date().getFullYear());

  // Kachel-Registry: Ausgabennummern + Farben der WaizmannTabellen.
  // Wird auf der Startseite (showOnHome) und im Bestellbereich (alle) genutzt.
  const waizmannTableTiles = ref([
    { id: "erwachsene", title: "WaizmannTabelle", subtitle: "Togo", label: "Erwachsene",          number: "No. 32", color: "#3166a5", ink: "light", colorClass: "home-hero__tile--blue",  showOnHome: true },
    { id: "60plus",     title: "WaizmannTabelle", subtitle: "60plus", label: "60plus",        number: "No. 1",  color: "#6f5aa8", ink: "light", colorClass: "home-hero__tile--lilac", showOnHome: false },
    { id: "kinder",     title: "WaizmannTabelle", subtitle: "Kinder", label: "KFO/Kind",        number: "No. 32", color: "#f2c14e", ink: "dark",  colorClass: "home-hero__tile--yellow", showOnHome: false },
    { id: "pzr",        title: "WaizmannTabelle", subtitle: "PZRPlus", label: "Prophylaxe",       number: "No. 4",  color: "#e24b8a", ink: "light", colorClass: "home-hero__tile--pink",  showOnHome: true },
    { id: "gesamt",     title: "WaizmannTabelle", subtitle: "Gesamtausgabe", label: "Gesamtausgabe", number: "No. 3",  color: "#9aa3af", ink: "light", colorClass: "home-hero__tile--gray",  showOnHome: true },
  ]);
  const homeTiles = computed(() => waizmannTableTiles.value.filter((t) => t.showOnHome));
  

  // Wichtig: Setup nur ausführen, wenn wir im Browser sind
  if (typeof window !== "undefined") {
    // Sofort hinzufügen (nicht in einem Hook wie onMounted)
    window.addEventListener("resize", () => {
      windowWidth.value = window.innerWidth;
    });
  }

  function getTimeAgo(datevor) {
    const now = new Date();
    const date = new Date(datevor);
    const diff = now - date; // difference in milliseconds
  
    const diffMinutes = Math.floor(diff / 60000);
  
    if (diffMinutes < 60) {
      return `vor ${diffMinutes} Minuten`;
    } else if (diffMinutes < 1440) {
      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours == 1) {
        return `vor einer Stunde`;
      } else {
        return `vor ${diffHours} Stunden`;
      }
    } else {
      const diffDays = Math.floor(diffMinutes / 1440);
      if (diffDays == 1) {  
        return `vor einem Tag`;
      } else {
        return `vor ${diffDays} Tagen`;
      }
    }
  }// Die Funktionen, die du verwenden möchtest


  function formatGermanDate(dateString) {
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      // second: '2-digit', // Falls die Sekunden benötigt werden
    };
    return date.toLocaleDateString('de-DE', options);
  }

  // Gib die reaktiven Daten und Methoden zurück
  return {
    windowWidth,
    getTimeAgo,
    isMobile,
    isIpadAndBelow,
    isDesktop,
    screenSize,
    showMenueRechts,
    formatGermanDate,
    thisYear,
    waizmannTableTiles,
    homeTiles,
  };
});
